import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  IMarketingCampaign,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import {
  CustomRecurrenceFrequency,
  RECURRENCE_FREQUENCY_DISPLAY_MAP,
  splitCamel,
  titlecase,
} from '@principle-theorem/shared';
import { IMarketingCampaignStepSummary } from '../campaign-steps-summary/campaign-step-summary';
import { CampaignStepsSummaryComponent } from '../campaign-steps-summary/campaign-steps-summary.component';
import { MarketingCampaign } from '@principle-theorem/principle-core';

@Component({
  selector: 'pr-campaign-entry-summary',
  templateUrl: './campaign-entry-summary.component.html',
  styleUrl: './campaign-entry-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, MatIconModule, CampaignStepsSummaryComponent],
  host: { class: 'flex flex-col gap-4' },
})
export class CampaignEntrySummaryComponent {
  campaign = input.required<IMarketingCampaign>();
  stepSummary = input.required<IMarketingCampaignStepSummary>();
  campaignSubject: Signal<string>;
  reentryScope: Signal<string | undefined>;
  patientSubject = titlecase(splitCamel(TemplateScope.Patient));

  constructor() {
    this.campaignSubject = computed(() =>
      titlecase(splitCamel(this.campaign()?.scope ?? TemplateScope.Patient))
    );
    this.reentryScope = computed(() => {
      const reentryScope = MarketingCampaign.reentryScope(this.campaign());
      return titlecase(splitCamel(reentryScope));
    });
  }

  frequencyLabel(frequency?: CustomRecurrenceFrequency): string {
    const unit = RECURRENCE_FREQUENCY_DISPLAY_MAP.find(
      (display) => display.value === frequency
    );
    return unit ? unit.displayName : frequency ?? '';
  }
}
